import { sanitizeURL } from '../../../core/js/utils/urlUtils';

/**
 * Setup Page.js routes
 * @param  {Page} pageRouter   Page.js Page object
 * @param  {String} base       Base URL for routes
 * @param  {Object} routes     An object mapping routes (Strings) to handler functions
 * @param  {Object} options    Options object for things like requiring trailing slashes on routes
 * @return {undefined}         pageRouter object is modified as a side-effect of this function
 */
export function setupRoutes(pageRouter, base, routes, options = {}) {
    const urlsRequireTrailingSlash = _.get(options, 'requireTrailingSlash', false);
    const redirectNonTrailingSlashToTrailingSlash = _.get(options, 'redirectToTrailingSlash', false);

    pageRouter.base(base);

    _.forEach(routes, (handlerFunc, route) => {
        let modifiedRouteName = _.cloneDeep(route);

        modifiedRouteName = sanitizeURL(modifiedRouteName, urlsRequireTrailingSlash);
        pageRouter(modifiedRouteName, handlerFunc);

        if (redirectNonTrailingSlashToTrailingSlash) {
            if (!_.endsWith(route, '/') && _.endsWith(modifiedRouteName, '/')) {
                pageRouter.redirect(route, modifiedRouteName);
            }
        }
    });
}
